import type { Styles } from "react-joyride";

/** Locale ລາວ — ໃຊ້ຮ່ວມກັນທຸກ tour */
export const appJoyrideLocale = {
  back: "ກັບ",
  close: "ປິດ",
  last: "ສິ້ນສຸດ",
  next: "ຕໍ່",
  open: "ເປີດ",
  skip: "ຂ້າມ",
};

/**
 * Joyride styles mapped to Sunlower brand tokens (styles/globals.css).
 * Uses CSS variables so light/dark mode follows the app theme.
 */
export const appJoyrideStyles: Partial<Styles> = {
  options: {
    primaryColor: "var(--primary)",
    textColor: "var(--foreground)",
    backgroundColor: "var(--card)",
    overlayColor: "color-mix(in oklch, var(--foreground) 42%, transparent)",
    arrowColor: "var(--card)",
    zIndex: 10000,
  },
  beacon: {
    outline: "none",
  },
  beaconInner: {
    backgroundColor: "var(--primary)",
  },
  beaconOuter: {
    backgroundColor: "color-mix(in oklch, var(--primary) 28%, transparent)",
    border: "2px solid var(--primary)",
  },
  overlay: {
    backgroundColor: "color-mix(in oklch, var(--foreground) 42%, transparent)",
  },
  spotlight: {
    borderRadius: "var(--radius-xl)",
  },
  tooltip: {
    borderRadius: "var(--radius-xl)",
    border: "1px solid var(--secondary)",
    padding: "20px 24px",
    backgroundColor: "var(--card)",
    color: "var(--card-foreground)",
    fontFamily: "var(--font-sans)",
    boxShadow:
      "0 12px 32px color-mix(in oklch, var(--foreground) 14%, transparent)",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  tooltipTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "var(--foreground)",
    marginBottom: "8px",
    fontFamily: "var(--font-display)",
  },
  tooltipContent: {
    fontSize: "14px",
    color: "var(--muted-foreground)",
    lineHeight: "1.55",
    padding: 0,
  },
  tooltipFooter: {
    marginTop: "16px",
  },
  buttonNext: {
    borderRadius: "9999px",
    backgroundColor: "var(--primary)",
    color: "var(--primary-foreground)",
    fontSize: "14px",
    fontWeight: 500,
    padding: "8px 18px",
    border: "1px solid color-mix(in oklch, var(--secondary) 35%, transparent)",
  },
  buttonBack: {
    borderRadius: "9999px",
    color: "var(--foreground)",
    fontSize: "14px",
    fontWeight: 500,
    padding: "8px 18px",
    border: "1px solid var(--border)",
    backgroundColor: "transparent",
  },
  buttonSkip: {
    borderRadius: "9999px",
    color: "var(--muted-foreground)",
    fontSize: "14px",
    fontWeight: 400,
    padding: "8px 14px",
  },
  buttonClose: {
    color: "var(--muted-foreground)",
    height: "12px",
    width: "12px",
  },
};
